var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSubwayCall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2868_7218)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.18755 8.78443C7.99537 8.38834 7.74693 8.10006 7.31802 8.27584L6.47193 8.5899C5.79459 8.90396 5.45709 8.5899 5.11724 8.11646L3.59381 4.6524C3.40396 4.25631 3.5024 3.88365 3.9313 3.70787L5.1149 3.23443C5.5438 3.05631 5.47584 2.686 5.28365 2.2899L4.27349 0.40084C4.0813 0.0047462 3.68755 -0.0913476 3.25865 0.0844337C2.39849 0.43834 1.68834 0.993809 1.22896 1.81647C0.666461 2.82193 0.947711 4.22115 1.06021 4.80943C1.17271 5.39772 1.56646 6.42896 2.07505 7.486C2.58365 8.54537 3.03131 9.3774 3.42974 9.8485C3.82818 10.3196 4.78443 11.6087 5.96802 11.8969C6.93834 12.1313 7.98599 11.9344 8.8438 11.5805C9.27271 11.4047 9.27505 11.0321 9.08287 10.6337L8.18755 8.78443ZM11.9704 3.2274L11.0469 2.30397L9.66177 3.68912L8.27662 2.30397L7.35318 3.2274L8.73834 4.61256L7.35318 6.00006L8.27662 6.9235L9.66177 5.53834L11.0469 6.9235L11.9704 6.00006L10.5852 4.6149L11.9704 3.2274Z",
    fill: "#774DFC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2868_7218"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubwayCall);
export default __webpack_public_path__ + "static/media/subwayCall.49ec2f7336254e2dcb62c95f627cc9c7.svg";
export { ForwardRef as ReactComponent };